export default __webpack_public_path__ + "static/media/396hz-Root-Chakra.a20d2c80.ogg";